/**
 * Local-calendar date helpers.
 *
 * `toISOString().slice(0, 10)` yields the UTC day — after ~22:00 CEST that is
 * already tomorrow's date minus one, i.e. the wrong calendar day for the user.
 * For fields that mean "the athlete's day" (quick-log, manual entries) build
 * the string from local clock components instead.
 */

/** Format a Date as YYYY-MM-DD using the device's local calendar. */
export function toLocalISODate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** Today as YYYY-MM-DD in the device's local calendar. */
export function todayLocalISO(): string {
  return toLocalISODate(new Date());
}
